function Plyn_sys_a_po_plynov(){
    return(
    <div>
        plynarske_systemy_a_pouzitie_plynov
    </div>
    );
}

export default Plyn_sys_a_po_plynov;